export default __webpack_public_path__ + "static/media/shader.d622c730.frag";